import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_BILL_SUMMARY, SET_PAYMENT_METHOD__DATA } from '../../redux/ActionName/ActionName';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import MyInput from '../../components/MyComponent/BillingInput';
import { calculateBillSummary } from '../../utils/utils';
import { CircleCheckBig } from 'lucide-react';
import AppButton from '../../components/AppButton/AppButton';
import { HitApi } from '../../Api/ApiHit';
import { verifyCoupon } from '../../constant/Constant';
import ToggleSwitch from '../../components/ToggelSwitch/ToggelSwitch';
import { getElevateUser } from '../../storage/Storage';
import { hasPermission } from '../../utils/permissionUtils';

export const PriceSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer);
    const dispatch = useDispatch();
    const ShowToggle = hasPermission('ngb', 'read');

    const [noGst, setNoGst] = useState()

    useEffect(() => {
        const userData = getElevateUser()
        setNoGst(userData?.roleData?.noGst)
    }, [])

    const handelChange = (name, value) => {
        let oldData = { ...BillingReducer?.billSummary };
        if (name === "notes") {
            oldData = { ...BillingReducer?.billSummary, notes: value }
            dispatch(setDataAction(oldData, SET_BILL_SUMMARY))
        }
        else {
            if (name === 'adjustPayment') {

                if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;

                var total = BillingReducer?.billSummary?.grandTotal - BillingReducer?.billSummary?.payingNow
                oldData[name] = total > Number(value) ? Number(value) : total
            }
            else if (name === "discountValue") {
                BillingReducer?.billSummary?.discountType === 'percentage'
                    ? oldData[name] = value > 100 ? 100 : value
                    : oldData[name] = value > BillingReducer?.billSummary?.subTotal + BillingReducer?.billSummary?.extraCharges ? BillingReducer?.billSummary?.subTotal + BillingReducer?.billSummary?.extraCharges : value
            }
            else if (name === "discountType") {
                oldData[name] = value
                if (value === 'percentage') {
                    BillingReducer?.billSummary?.discountValue > 100 ? oldData['discountValue'] = 100 : oldData['discountValue'] = BillingReducer?.billSummary?.discountValue
                }
            }
            else {

                oldData[name] = value
            }
            dispatch(setDataAction(oldData, SET_BILL_SUMMARY));
            const updatedBillingReducer = { ...BillingReducer, billSummary: oldData };
            calculateBillSummary(updatedBillingReducer, dispatch, name === 'adjustPayment' ? true : false);
        }
    };
    const handelClick = (index) => {
        const oldPaymentMethod = [...BillingReducer.paymentMethod]
        const originalGrandTotal = BillingReducer?.billSummary?.grandTotal || 0;
        const currentAdjustPayment = BillingReducer?.billSummary?.adjustPayment || 0;
        const currentItemPrice = oldPaymentMethod[index].price || 0;
        oldPaymentMethod[index] = { ...oldPaymentMethod[index], price: currentItemPrice > 0 ? 0 : currentAdjustPayment, };
        const totalPaymentPrices = oldPaymentMethod.reduce((sum, item) => sum + (item.price || 0), 0);
        const updatedBillSummary = { ...BillingReducer?.billSummary, adjustPayment: originalGrandTotal - totalPaymentPrices, };
        dispatch(setDataAction(oldPaymentMethod, SET_PAYMENT_METHOD__DATA));
        dispatch(setDataAction(updatedBillSummary, SET_BILL_SUMMARY));
        const updatedBillingReducer = { ...BillingReducer, paymentMethod: oldPaymentMethod };
        calculateBillSummary(updatedBillingReducer, dispatch);
    };
    const handelCoupon = () => {
        let json = {
            couponCode: BillingReducer.billSummary.couponCode,
            customerPhone: BillingReducer.billSummary.couponCode
            // claimId: "6899a4f87fe642bbea2d2c52",
            // originalAmount: 10000
        }
        HitApi(json, verifyCoupon).then((res) => {
            console.log("resss coupon wala", res);
            let oldData = { ...BillingReducer.billSummary }
            oldData = { ...oldData, discountValue: res.discountPercentage }
            dispatch(setDataAction(oldData, SET_BILL_SUMMARY))
            const updatedBillingReducer = { ...BillingReducer, billSummary: oldData };
            calculateBillSummary(updatedBillingReducer, dispatch);
        })
    }



    return (
        <div className="bg-white rounded-xl shadow-lg p-6">
            {/* Charges, Discount, GST */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                <div>
                    <MyInput title={'Ex Charges'} disable={BillingReducer?.billSummary?.subTotal === 0 ? true : ""} onChange={(e) => handelChange('extraCharges', e.target.value)} type="number" value={BillingReducer?.billSummary?.extraCharges || ''} />
                </div>
                <div>
                    <MyInput title={'Discount'} disable={BillingReducer?.billSummary?.subTotal === 0 ? true : ""} onChange={(e) => handelChange('discountValue', e.target.value)} type="number" value={BillingReducer?.billSummary?.discountValue || ""} />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Discount Type</label>
                    <select onChange={(e) => handelChange('discountType', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent">
                        <option value="percentage" selected={BillingReducer?.billSummary?.discountType === 'percentage'}>Percentage (%)</option>
                        <option value="flat" selected={BillingReducer?.billSummary?.discountType === 'flat'}>Fixed Amount</option>
                    </select>
                </div>
                <div>
                    <MyInput title={'GST %'} onChange={(e) => handelChange('gstPercentage', e.target.value)} type="number" value={BillingReducer?.billSummary?.gstPercentage || ''} />
                </div>
                {ShowToggle && <div className='flex justify-center items-center mt-8 mr-20'>
                    <ToggleSwitch />
                </div>}
            </div>
            {/* Payment Methods */}
            <div className="mb-6">
                <div className="flex gap-4 mb-4">
                    {BillingReducer?.paymentMethod?.map((method, index) => (
                        <button key={method.title} onClick={() => handelClick(index)} className={`relative px-4 py-2 rounded-lg border transition-colors ${method.price !== 0 ? ' bg-gray-200 text-gray-700' : 'bg-gray-50 text-gray-700 '}`} >
                            <div className='flex gap-1' >
                                {method.title}
                                {method.price !== 0 &&
                                    <div>
                                        <span>{method.price}</span>
                                        <span className="absolute top-[-4px] right-[-6px]">
                                            <CircleCheckBig stroke="green" size={16} />
                                        </span>
                                    </div>
                                }
                            </div>
                        </button>
                    ))}
                </div>
            </div>
            {/* Adjust Payment */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <MyInput onChange={(e) => handelChange('adjustPayment', e.target.value)} title={"Adjust Payment"} type="number" value={BillingReducer?.billSummary?.adjustPayment} />
                </div>
            </div>
            {/* Coupn code hai yaha */}
            <div className='flex gap-4 mt-2'>
                <div>
                    <MyInput onChange={(e) => handelChange('couponCode', e.target.value)} type title={"Coupon Code"} value={BillingReducer?.billSummary?.couponCode} />
                </div>
                <div className='mt-7'>
                    <AppButton buttontext={"Apply"} onClick={handelCoupon} />
                </div>
            </div>
            {/* Notes */}
            <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Enter Notes</label>
                <textarea
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    rows="3"
                    placeholder="Enter Notes"
                    value={BillingReducer?.billSummary?.notes}
                    onChange={(e) => handelChange("notes", e.target.value)

                    }
                />
            </div>
        </div>
    );
};
